import { render } from "./SelectWrapper.vue?vue&type=template&id=2213c3ee&scoped=true"
import script from "./SelectWrapper.vue?vue&type=script&lang=js"
export * from "./SelectWrapper.vue?vue&type=script&lang=js"

import "./SelectWrapper.vue?vue&type=style&index=0&id=2213c3ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2213c3ee"]])

export default __exports__